if (window.location.href.includes('&target=') && !window.location.href.includes('all-brands?')) {
    let theurl = window.location.href.split('&target=');
    localStorage.setItem("currentSubcollection", theurl[1].replaceAll('%20', ' '));
  }
  
  if (window.location.href.includes('all-brands?')) {
    let theurl = window.location.href.includes('brand=') ? window.location.href.split('brand=') : window.location.href.split('vendor=')
    let theBrand = theurl.length >= 2 ? theurl[1].replaceAll('%20', ' ').replaceAll('+', ' ') : 'other';
  
    localStorage.setItem("theBrand", 'true');
    localStorage.setItem("currentSubcollection", theBrand);
  } else {
    setTimeout(function () {
      localStorage.setItem("theBrand", 'false');
    }, 1000)
  }
  
  if (window.location.href.includes('/collections/') && sessionStorage.getItem("breadcrumb2") != null && localStorage.getItem("theBrand") == 'true' && !sessionStorage.getItem("breadcrumb2").includes('all-brands')) {
    sessionStorage.setItem("breadcrumb", sessionStorage.getItem("breadcrumb2"));
  }
  
  function removeNextObjects(array, valueToRemove) {
    const index = array.findIndex(obj => obj.link === valueToRemove);
    if (index !== -1) {
      array.splice(index + 1); // Removes all elements from index + 1 onwards
    }
  }
  
  function checkValueContains(obj, secondVal, currentPage) {
    let checker = false;
    obj.forEach(function (e) {
      if (e.link == link) {
        checker = true;
      }
    });
    // console.log('breadcrumbs', obj)
    // console.log('secondVal', secondVal)
    // console.log('currentPage', currentPage)
    if (checker == false) {
      if(obj[2]?.location == "" && secondVal.location == ""){
        obj[2] = secondVal
      } else if(secondVal.title == obj[1]?.title){
        obj[1] = secondVal
      } else if (obj[2]?.location == "" && secondVal.location == "/collections/load-management-parts"){
        obj[2] = secondVal
      } else {
        obj.push(secondVal);
      }
    }
  
    const myJSON = JSON.stringify(obj);
    if (!window.location.href.includes('&page')) {
      sessionStorage.setItem("breadcrumb", myJSON);
    }
    let breadcrumbmain = sessionStorage.getItem("breadcrumb");
    const obj2 = JSON.parse(breadcrumbmain);
  
    removeNextObjects(obj2, currentPage);
  
    let breadcrumb = '';
    let len = JSON.stringify(obj2);
    
    sessionStorage.setItem("breadcrumb", len);
  
    obj2.forEach(function (e, index) {
      let collection_name = e.title;
      breadcrumb += `<li class="breadcrumbs-list__item flex items-center">
                        <a class="breadcrumbs-list__link" href="${e.link}" target="_self">${collection_name}</a>
                        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg>
                      </li>`;
    });
    if (location_ != '/') {
      document.querySelector(".breadcrumbs-list") && (document.querySelector(".breadcrumbs-list").innerHTML = breadcrumb);
    }
  
  }
  
  let location_ = window.location.pathname;
  let link = window.location.href;
  
  if (location_ == '/') {
    sessionStorage.removeItem("breadcrumb");
  }
  
  if (window.location.href.includes('all-brands')) {
    sessionStorage.removeItem("breadcrumb");
  }
  
  document.querySelectorAll(".main-menu .mega-nav a").forEach(function (elem) {
    // Code in header file as well
    elem.addEventListener("click", function (e) {
      if (sessionStorage.getItem("current_page").includes('/collections/') && sessionStorage.getItem("breadcrumb") != null) {
        sessionStorage.setItem("breadcrumb2", sessionStorage.getItem("breadcrumb"));
      }
      sessionStorage.removeItem("breadcrumb");
    });
  });
  
  let breadcrumbItems = sessionStorage.getItem("breadcrumb");
  let currentSubcollection = localStorage.getItem("currentSubcollection");
  let currentSubcollectionUrl = localStorage.getItem("currentSubcollectionUrl");
  sessionStorage.setItem("current_page", `"${document.referrer}"`);
  sessionStorage.setItem("current-page", `${window.location.href}`);
  let currentPage = sessionStorage.getItem("current-page");
  let current_page = sessionStorage.getItem("current_page");
  if (location_ != '/') {
    document.querySelector(".breadcrumbs-list") && (document.querySelector(".breadcrumbs-list").innerHTML = '');
  }
  if (breadcrumbItems == null) {
    sessionStorage.setItem("breadcrumb", `[{"location":"/","link":"/","title":"Home"}]`);
  }
  if (location_ != '/') {
    let secondVal;
    breadcrumbItems = sessionStorage.getItem("breadcrumb");
    let obj = JSON.parse(breadcrumbItems);
    
    if (window.location.href.includes('/collections') || window.location.href.includes('/products')) {
      for (let i2 = 0; i2 < obj.length; i2++) {
        if (obj[i2].link.includes('/pages/') || obj[i2].link.includes('/cart') || obj[i2].link.includes('/search') || (obj[i2].link.includes('/search') && obj[i2].link != link)) {
          obj.splice(i2, 1);
          break;
        }
      }
    }
  
    if (window.location.href.includes('collection_anchor') || window.location.href.includes('?filter')) {
      for (let i2 = 0; i2 < obj.length; i2++) {
        if (obj[i2].link.includes('collection_anchor') && obj[i2].link != link) {
          obj.splice(i2, 1);
          break;
        }
      }
  
      if (window.location.href.includes('?filter')) {
        let filterOne = link.split('?filter');
        fetch(filterOne[0] + ".json")
          .then(response => response.json())
          .then(data => {
            console.log('data', data)
            secondVal = {
              "location": "",
              "link": currentSubcollectionUrl,
              "title": currentSubcollection
            };
            let checker = false;
            obj.forEach(function (e) {
              if (e.link == filterOne[0]) {
                checker = true;
              }
            });
            if (checker == false) {
              checkValueContains(obj, {
                "location": filterOne[0],
                "link": filterOne[0],
                "title": data.collection.title
              }, currentPage);
            }
            checkValueContains(obj, secondVal, currentPage);
          });
      }
    } else {
  
      for (let i2 = 0; i2 < obj.length; i2++) {
        if (obj[i2].link.includes('/products/') && obj[i2].link != link) {
          obj.splice(i2, 1);
          break;
        }
      }
      if (window.location.href.includes('&page=')) {
  
      } else {
        secondVal = {
          "location": location_,
          "link": link,
          "title": theTitle
        };
      }
      checkValueContains(obj, secondVal, currentPage);
    }
  }